function trackABTestEvent(chosenVariant, testName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'ab_test_view',
    test_name: testName,
    variant: `${testName}-${chosenVariant}`,
  });
}

function chooseABTestVariant(variantKeys, testName, variants) {
  const storageKey = `ab-test-${testName}`;
  let chosenVariant = localStorage.getItem(storageKey);

  // Если в localStorage нет варианта — выбираем случайный
  if (!chosenVariant || !variants[chosenVariant]) {
    chosenVariant = variantKeys[Math.floor(Math.random() * variantKeys.length)];
    localStorage.setItem(storageKey, chosenVariant);
  }

  return chosenVariant;
}

function runABTesting() {
  const allTestElements = document.querySelectorAll('[data-ab-testing="true"]');
  const tests = {};

  allTestElements.forEach((htmlElement) => {
    const variant = htmlElement.getAttribute('data-ab-variant');
    const [testName, variantLabel] = variant.split('-');

    if (!tests[testName]) {
      tests[testName] = {};
    }

    tests[testName][variantLabel] = htmlElement;
  });

  Object.keys(tests).forEach((testName) => {
    const variants = tests[testName];
    const variantKeys = Object.keys(variants);

    if (variantKeys.length < 2) return; // Не показываем тест, если только один вариант

    let chosenVariant = chooseABTestVariant(variantKeys, testName, variants);

    // Показываем выбранный вариант, скрываем остальные
    variantKeys.forEach((key) => {
      const variantElement = variants[key];
      if (key === chosenVariant) {
        variantElement.style.display = '';
        trackABTestEvent(chosenVariant, testName);
      } else {
        variantElement.style.display = 'none';
      }
    });
  });
};

runABTesting();